import _ from "lodash";

export const makeComparator = (getCurrent, getSaved, customizer) => (state) =>
  _.isEqualWith(getCurrent(state), getSaved(state), customizer);
